module.exports = __webpack_public_path__ + "sgby/img/side-open.43bad3b.png";